import trySaveMessage from '../../actions/trySaveMessage';
import createSignatureBlock from '../../utils/createSignatureBlock';
import getSignature from '../../utils/getSignature';
import { isViewStateDirty } from '../../utils/viewStateUtils';
import updateContent from 'owa-editor/lib/actions/updateContent';
var ContentOperationPlugin = /** @class */ (function () {
    function ContentOperationPlugin(viewState) {
        this.viewState = viewState;
        this.name = 'ContentOperation';
    }
    ContentOperationPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
        this.saveOnDispose = true;
    };
    ContentOperationPlugin.prototype.dispose = function () {
        if (this.saveOnDispose) {
            this.cursorSnapshot = {};
            if (this.editor && this.editor.getSelectionRange()) {
                this.cursorSnapshot.htmlSnapshotWithCursorMarker = this.utils.buildSnapshot(this.editor);
            }
            this.updateContentToViewState();
            this.cursorSnapshot.snapshot = this.viewState.content;
            if (isViewStateDirty(this.viewState) &&
                !this.viewState.subjectPickerViewState.isLoadingConversation) {
                trySaveMessage(this.viewState, true /*isAutoSave*/);
            }
        }
        this.saveOnDispose = false;
        this.editor = null;
    };
    ContentOperationPlugin.prototype.setPluginUtils = function (utils) {
        this.utils = utils;
    };
    ContentOperationPlugin.prototype.hasCursorSnapshot = function () {
        return this.cursorSnapshot && this.cursorSnapshot.htmlSnapshotWithCursorMarker;
    };
    ContentOperationPlugin.prototype.focusToEditor = function () {
        if (this.editor) {
            this.editor.focus();
            if (this.hasCursorSnapshot() &&
                this.cursorSnapshot.snapshot == this.viewState.content) {
                this.utils.restoreSnapshot(this.editor, this.cursorSnapshot.htmlSnapshotWithCursorMarker);
                this.editor.triggerContentChangedEvent('RestoreCursor');
            }
        }
        else if (this.plainTextEditor) {
            this.plainTextEditor.focus();
            this.plainTextEditor.selectionStart = 0;
            this.plainTextEditor.selectionEnd = 0;
        }
        this.cursorSnapshot = null;
    };
    ContentOperationPlugin.prototype.stopSaveOnDispose = function () {
        this.saveOnDispose = false;
    };
    ContentOperationPlugin.prototype.updateContentToViewState = function () {
        var content = this.editor
            ? this.editor.getContent(true /*triggerExtractContentEvent*/)
            : this.plainTextEditor ? this.plainTextEditor.value : null;
        if (content != null) {
            updateContent(this.viewState, content);
        }
    };
    ContentOperationPlugin.prototype.setPlainTextEditor = function (plainTextEditor) {
        this.plainTextEditor = plainTextEditor;
    };
    ContentOperationPlugin.prototype.onPluginEvent = function (event) {
        if (event.eventType === 6 /* ContentChanged */) {
            var contentChangedEvent = event;
            if (contentChangedEvent.source === "SetContent" /* SetContent */) {
                if (this.replyWithTextElementId) {
                    // Wait until the text element has been inserted before moving the caret
                    this.moveCaretBelowHtmlElement(this.replyWithTextElementId);
                }
            }
        }
    };
    ContentOperationPlugin.prototype.insertSignature = function (bodyType) {
        var signatureText = createSignatureBlock(bodyType, getSignature(bodyType));
        if (bodyType == 'HTML' && this.editor) {
            this.editor.focus();
            this.editor.addUndoSnapshot();
            this.editor.insertContent(signatureText, {
                position: 2 /* SelectionStart */,
                updateCursor: false,
                replaceSelection: true,
                insertOnNewLine: true,
            });
            this.editor.triggerContentChangedEvent('Signature');
            this.editor.addUndoSnapshot();
        }
        else if (bodyType == 'Text' && this.plainTextEditor) {
            var cursorPosition = this.plainTextEditor.selectionEnd;
            var newContent = this.plainTextEditor.value.substr(0, cursorPosition) +
                signatureText +
                this.plainTextEditor.value.substr(cursorPosition);
            this.plainTextEditor.value = newContent;
        }
    };
    ContentOperationPlugin.prototype.moveCaretBelowHtmlElement = function (elementId) {
        if (!this.editor) {
            // The first time this method is called, the editor is not yet initialized and the
            // quote element has not yet been inserted
            // Remember the element's ID for now, and this function will be called again later
            this.replyWithTextElementId = elementId;
            return;
        }
        this.placeCursorAfterElement(elementId);
    };
    ContentOperationPlugin.prototype.isEmpty = function () {
        return this.editor && this.editor.isEmpty();
    };
    ContentOperationPlugin.prototype.removeInlineImage = function () {
        var images = this.editor.queryContent('img');
        for (var i = 0; i < images.length; i++) {
            this.editor.deleteNode(images[i]);
        }
    };
    ContentOperationPlugin.prototype.getTextContent = function () {
        return this.editor && this.editor.getTextContent();
    };
    ContentOperationPlugin.prototype.insertHtmlIntoEditor = function (html, eventName) {
        if (this.editor) {
            this.editor.focus();
            this.editor.addUndoSnapshot();
            this.editor.insertContent(html, {
                insertOnNewLine: true,
                position: 2 /* SelectionStart */,
                replaceSelection: false,
                updateCursor: true,
            });
            this.editor.triggerContentChangedEvent(eventName);
            this.editor.addUndoSnapshot();
        }
    };
    ContentOperationPlugin.prototype.placeCursorAfterElement = function (elementId) {
        var element = this.editor.getDocument().getElementById(elementId);
        if (element) {
            this.editor.focus();
            var selection = this.editor.getDocument().createRange();
            selection.selectNode(element);
            selection.collapse(false);
            this.editor.updateSelection(selection);
        }
    };
    return ContentOperationPlugin;
}());
export default ContentOperationPlugin;
//# sourceMappingURL=ContentOperationPlugin.js.map